/** @format */
import { useContext } from 'react';

import { useFeatureFlag } from '@toucan/client/global/feature-flag';
import { Market, MarketContext } from '@toucan/client/global/market';

import { getHelpCentreUrl } from '../../helpers';

export const useHelpCentreUrl = (
    market?: Market,
    forceConsolidatedMarket?: boolean
) => {
    const isConsolidatedIntercom = Boolean(
        useFeatureFlag('APE-3584-(consolidate-intercom-workspaces)')?.isEnabled
    );
    const { activeMarket } = useContext(MarketContext);

    return getHelpCentreUrl({
        market: market ?? activeMarket,
        isConsolidatedIntercomConfigActive:
            forceConsolidatedMarket ?? isConsolidatedIntercom,
    });
};
